import { SalesRulePricingTypeModel } from 'generated/graphql';

// 移动端
export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mini|Mobile|OpenHarmony|ArkWeb/i.test(
        window.navigator.userAgent,
    );
}

// ios
export const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);

// 微信内
export const isInWechat = /MicroMessenger/i.test(window.navigator.userAgent);

// 应用内
export const isInApp = /qxwz/i.test(window.navigator.userAgent);

// 微信小程序
export const isWeapp = (window as any).__wxjs_environment === 'miniprogram';

// 微信小程序渠道
export const isWeappChannel = isWeapp ? 'WX_MP' : 'M';

export const isViewMode =
    /qxwz-user-mode\/view/i.test(window.navigator.userAgent) || window.location.href.includes('qxwz-user-mode=view');

export const showSecretProtocal = () => {
    if ((window as any)?.protocal?.show) {
        (window as any).protocal.show();
    }
};

export const serviceGroupEnum = {
    virtualBrand$qianxunweizhi$FindCM: 'FINDCM',
    virtualBrand$qianxunweizhi$FindM: 'FINDM',
    virtualBrand$qianxunweizhi$FindMM: 'FINDMM',
    virtualBrand$qianxunweizhi$FindS: 'FINDS',
    virtualBrand$qianxunweizhi$FindX: 'FINDX',
    virtualBrand$qianxunweizhi$FindMPro: 'FINDMPRO',
};

export function getServiceGroupHost(code: string) {
    const codeEnum = serviceGroupEnum[code];
    switch (codeEnum) {
        case 'FINDCM':
            return `//findcm.my.${commonHost}`;
        case 'FINDMPRO':
            return `//findmpro.my.${commonHost}`;
        case 'FINDM':
            return `//findm.my.${commonHost}`;
        case 'FINDMM':
            return `//findmm.my.${commonHost}`;
        case 'FINDS':
            return `//finds.my.${commonHost}`;
        default:
            return '//www.qxwz.com';
    }
}

export function appendScript(url: string) {
    const script = document.createElement('script');
    script.async = true;
    script.charset = 'utf-8';
    script.setAttribute('data-args', 'manual=true');
    script.src = url || '';
    document.head.appendChild(script);
    return new Promise(resolve => {
        script.onload = () => {
            resolve(script);
        };
    });
}

export function appendStyle(href: string) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.id = 'app-style';
    head.appendChild(link);

    return new Promise(resolve => {
        link.onload = () => {
            resolve(link);
        };
    });
}

export function formatCurrency(num: number | string | null | undefined, prefix?: boolean) {
    let amount = '0.00';
    if (num) {
        amount = (+num).toFixed(2);
    }

    return prefix ? `¥ ${amount}` : amount;
}

export const splitCurrency = (num: number | string | null | undefined) => formatCurrency(num).split('.');

export function trackPage(event: string | undefined | null, params: string | undefined | null) {
    if (window.sensors) {
        const dom = document.querySelector('[data-sa-page]');
        // eslint-disable-next-line no-param-reassign
        event = event || (dom && dom.getAttribute('data-sa-page'));
        // eslint-disable-next-line no-param-reassign
        params = params || (dom && dom.getAttribute('data-sa-params')) || '{}';
        if (event && params) {
            try {
                window.sensors.track(event, JSON.parse(params));
            } catch (error) {
                console.log(error && (error as any)?.message);
            }
        }
    }
}

export function isSKZN(subCategory: string) {
    return ['category$virtual$space', 'category$package$space', 'category$entity$space'].indexOf(subCategory) !== -1;
}

export function redirectToSkznUrl(subCategory: string, history) {
    if (!isSKZN(subCategory)) return;
    if (!history.location.pathname.startsWith('/skzn')) {
        window.location.href = `/market/skzn${history.location.pathname}`;
    }
}

export function isPackageCommodity(category?: string) {
    return category === 'category$package';
}

export function isServiceCommodity(category?: string) {
    return category === 'category$virtual';
}

export function isEntityCommodity(category?: string) {
    return category === 'category$entity';
}

export function isCommoditySaleable(commodityStatus?: string) {
    return commodityStatus?.toLocaleLowerCase() === 'already_released';
}

// 设置排序因子，按字母升序排列
const PRICING_TYPE_ORDER = {
    pricingType$time$month: 'a1',
    pricingType$time$season: 'b1',
    pricingType$time$year: 'c1',
    pricingType$time$day: 'd1',
};

export function sortPricingType<T extends SalesRulePricingTypeModel>(pricingTypeList: T[]): T[] {
    return pricingTypeList.sort((a, b) => {
        let compare = (PRICING_TYPE_ORDER[a.pricingType as string] || 'zz').localeCompare(
            PRICING_TYPE_ORDER[b.pricingType as string] || 'zz',
        );
        if (!compare) {
            return (a.quantity as number) - (b.quantity as number);
        }
        return compare;
    });
}

/**
 * 是否为生产环境： prod
 */
// eslint-disable-next-line
export const isProd = location.hostname.includes('.qxwz.com') && !/\.(pre|stage)\./.test(location.hostname);

/**
 * 转换成当前环境的网址
 * @param {string} link
 * @param {string} _host 当前 host，用于 mock test
 */
export function normalizeLink(link: string) {
    link = proLink(link) || '';
    if (!link || link === '#') {
        // eslint-disable-next-line
        return 'javascript:void(0)';
    }
    // bbs.qxwz.com, static0.qxwz.com, static.qxwz.com 只有生产环境，其他的替换为测试是链接
    if (/^\/\/(bbs|static\d+)\./i.test(link) || isProd) {
        return link;
    }
    // for jest mock test
    // eslint-disable-next-line
    const host = location.href ? `.${commonHost}` : `.${getCommonHost()}`;
    return link.replace(/\.qxwz\.com/gi, host).replace('.my.pre.', '.pre.my.');
}

const qxHost = /pre\.qxwz|stage\.qxwz|qxwz-\w+\.web\.wz-inc/gi;
/**
 * 转换成线上环境的网址，配置成线下时，强制改为线上生产环境 pre.qxwz, stage.qxwz, qxwz-test4.web.wz-inc
 * @param {string} link
 */
export function proLink(link: string) {
    // fix: xxx.pre.my.qxwz.com
    link = link?.replace?.(qxHost, 'qxwz').replace('.pre', '');
    return removePrefix(link);
}

/**
 * 移除前缀，便于线下域名不支持 https
 * `https://passport.qxwz.com/login -> //passport.qxwz.com/login`
 * @param {string} url
 */
export function removePrefix(url: string) {
    return url?.replace?.(/^https?:/gi, '') || '';
}

/**
 * 基础域名
 */
export const baseHost = 'qxwz.com';

/**
 * 当前网页默认 commonHost: .qxwz.com
 */
export const commonHost = getCommonHost();

/**
 * 根域名，用于种 cookie，各业务域名之间跳转
 * `www.qxwz-daily.web.wz-inc.com, findcm.my.qxwz-daily.web.wz-inc.com --> .qxwz-daily.web.wz-inc.com`
 * `findcm.my.qxwz.com, mall.qxwz.com --> .qxwz.com`
 * `amb-my.stage.qxwz.com --> .stage.qxwz.com`
 * `https://cdn.wzw.cn/material/demo.html -> .qxwz.com`
 * `https://dev-venus-pub.oss-cn-beijing.aliyuncs.com/material/demo.html -> .qxwz.com`
 */
export function getCommonHost() {
    // eslint-disable-next-line
    if (location.hostname === 'localhost') {
        return 'qxwz-daily.web.wz-inc.com';
    }
    // eslint-disable-next-line
    return (location.hostname.includes('.qxwz') && location.hostname.replace(/^\w+\.|^[\w-]+|\.my/g, '')) || baseHost;
}

export function initializeVConsole() {
    const scriptUrl = '//lf3-cdn-tos.bytecdntp.com/cdn/expire-1-M/vConsole/3.12.1/vconsole.min.js';
    const shouldInitialize = new URLSearchParams(window.location.search).get('__vconsole') === '1';

    if (shouldInitialize && !document.querySelector(`script[src="${scriptUrl}"]`)) {
        appendScript(scriptUrl).then(() => {
            new (window as any).VConsole();
        });
    }
}
